module.exports = __webpack_public_path__ + "img/two.27404389.png";